import { SearchContext } from "context/providers";
import { useContext } from "react";

const CommunityBoost = ({ disabled }) => {
  const { searchState, handleCommunityBoosChange } = useContext(SearchContext);

  const options = [
    { label: "High", value: "HIGH" },
    { label: "Medium", value: "MEDIUM" },
    { label: "Low", value: "LOW" },
    { label: "None", value: "NONE" },
  ];

  const handleChange = ({ target }) => {
    handleCommunityBoosChange(target.value || "NONE");
  };

  return (
    <div class="ais-Panel-body">
      <div class="ais-SortBy">
        <select
          class="ais-SortBy-select"
          value={searchState.communityBoost || "NONE"}
          onChange={handleChange}
          disabled={disabled}
        >
          {options.map((item) => {
            return (
              <option
                key={item.label}
                class="ais-SortBy-option"
                value={item.value}
              >
                {item.label}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

export default CommunityBoost;
